import {writable} from 'svelte/store';

const {set, update, subscribe} = writable({
    visible: false,
    type: null, // 'confirm', 'alert', 'error'
    prompt: null,
    yes_callback: null,
    no_callback: null,
});

const app_alert = {
    set, update, subscribe,
    show: (type, prompt, yes_callback = null, no_callback = null) => {
        update(state => {
            state.visible = true;
            state.type = type;
            state.prompt = prompt;
            state.yes_callback = yes_callback;
            state.no_callback = no_callback;
            return state;
        })
    }, hide: () => {
            update(state => {
            state.type = null;
            state.visible = false;
            state.prompt = null;
            state.yes_callback = null;
            state.no_callback = null;
            return state;
        })
    }
}
export default app_alert;